/**
 * GlowText.jsx
 *
 * Modern replacement for the old LedText / PixelText 5×7 dot-matrix
 * renderer. Uses the real Orbitron display font with a neon glow —
 * crisper, fully responsive (no per-character pixel math needed), and
 * matches the new Mech-HUD design language.
 *
 * Props:
 *   text      {string}            Text to render
 *   as        {string}            Tag to render ('span' | 'div' | 'h1'…)
 *   size      {number|string}     Font size — number = px, or pass a CSS value
 *   variant   {'cyan'|'violet'|'magenta'|'amber'|'white'|'danger'}
 *   weight    {number}            font-weight (default 700)
 *   mono      {boolean}           Use the mono HUD readout font instead of Orbitron
 *   className {string}
 */
import React from 'react';

export default function GlowText({
  text,
  as: Tag = 'span',
  size = 16,
  variant = 'cyan',
  weight = 700,
  mono = false,
  className = '',
  style = {},
  ...rest
}) {
  const fontSize = typeof size === 'number' ? `${size}px` : size;
  return (
    <Tag
      className={`${mono ? 'font-mono-hud' : 'glow-text'} glow-${variant} ${className}`}
      style={{ fontSize, fontWeight: mono ? 500 : weight, ...style }}
      {...rest}
    >
      {text}
    </Tag>
  );
}
